import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
import { CiviliteTitles } from "@inspire/data/static/pedagogie";
var ProfProfileSchema = new SimpleSchema({
    title: {
        type: String,
        optional: true,
        allowedValues: Object.keys(CiviliteTitles)
    },
    hadInspirePresentation: {
        type: Boolean,
        optional: false,
        defaultValue: false
    },
    pedagogie_filiere_generale: {
        type: Boolean,
        defaultValue: false,
        optional: true
    },
    pedagogie_filiere_technologique: {
        type: Boolean,
        defaultValue: false,
        optional: true
    },
    pedagogie_filiere_professionnelle: {
        type: Boolean,
        defaultValue: false,
        optional: true
    }
});
export { ProfProfileSchema };
